import { createChildListViewContainer } from 'factories/ChildListView'
import Component from 'components/Assets/Tasks'

export default createChildListViewContainer()(Component)
